<template>
  <div id="dashboard" class="dashbord">
    <!-- :orders="jobs"
    :setpacking="packing"
    :setmyjob="myjobs"
    :setready="ready" -->
    <navbarStaff />
    <div class="space"></div>
    <b-container class="bv-example-row">
        <br/>
      <div class="tebs_content">
        <div class="tebs_floting">
          <div class="row">
            <div class="col-5">
              <div class="circle_content">
                <div class="circle_floting">
                  <div class="circle">
                    <span class="circle__btn">
                      <img
                        class="circle_img"
                        :src="require('@/assets/avatars/' + code + '.jpg')"
                        alt=""
                      />
                      <!-- <ion-icon class="pause" name="pause"></ion-icon>
                          <ion-icon class="play" name="play"></ion-icon> -->
                    </span>
                    <span class="circle__back-1"></span>
                    <span class="circle__back-2"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-7">
              <br />
              <div class="segmented-control">
                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value=""
                  id="tab-1"
                  checked
                />
                <label for="tab-1" class="segmented-control__1"> <p>All</p></label>
                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value="MyJob"
                  id="tab-2"
                />
                <label for="tab-2" class="segmented-control__2">
                  <p>MyJob</p>
                  <span class="icon-button__badge_myjob">
                    {{ myjobs + +(myjobs > 1 || myjobs == 0 ? "0" : "") }}
                  </span></label
                >
        
                <input
                  type="radio"
                  name="radio2"
                  v-model="radio_btn"
                  @change="onChange"
                  value="NewOrder"
                  id="tab-3"
                />
                <label for="tab-3" class="segmented-control__3">
                  <p>NewOrder</p>
        
                  <span class="icon-button__badge_new_order">
                    {{ jobs + +(jobs > 1 || jobs == 0 ? "0" : "") }}
                  </span></label
                >
        
                <div class="segmented-control__color"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="space"></div>
      <br />
       <!-- ====================================== AVARTAR ================================================= -->
       <!-- <div class="circle pull-left">
        <span class="circle__btn">
          <img
            class="circle_img"
            :src="require('@/assets/avatars/' + code + '.jpg')"
            alt=""
          />

        </span>
        <span class="circle__back-1"></span>
        <span class="circle__back-2"></span>
      </div> -->
       <!-- ====================================== TABS MENU =============================================== -->
       <!-- <div class="space"></div>
       <div class="segmented-control">
        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value=""
          id="tab-1"
          checked
        />
        <label for="tab-1" class="segmented-control__1"> <p>All</p></label>
        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value="MyJob"
          id="tab-2"
        />
        <label for="tab-2" class="segmented-control__2">
          <p>MyJob</p>
          <span class="icon-button__badge_myjob">
            {{ myjobs + +(myjobs > 1 || myjobs == 0 ? "0" : "") }}
          </span></label
        >

        <input
          type="radio"
          name="radio2"
          v-model="radio_btn"
          @change="onChange"
          value="NewOrder"
          id="tab-3"
        />
        <label for="tab-3" class="segmented-control__3">
          <p>NewOrder</p>

          <span class="icon-button__badge_new_order">
            {{ jobs + +(jobs > 1 || jobs == 0 ? "0" : "") }}
          </span></label
        >

        <div class="segmented-control__color"></div>
      </div> -->
      <!-- ===================================== END TABS MENU ============================================ -->
      <!-- <b-row>
        <b-col cols="5">
         
        </b-col>
        <b-col cols="7">
         
        </b-col>
      </b-row> -->

      <!-- ================================== END AVARTAR ================================================= -->

      <!-- ======================================== Detail Tabs ============================================= -->
      <!-- ======================================== All =================================================== -->
      <!-- <div class="detail" v-if="radio_btn === ''">
        <div class="card-columns-two">
          <div class="card-columns"></div>
        </div>
      </div> -->
      <br/>

      <div v-if="radio_btn === ''">
        <!-- <div class="card-columns-two"> -->
        <div class="card-columns">
          <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-8 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body ">
                  <div class="chip pull-left">
                    <div class="chip__icon">
                      <i class="fa-solid fa-bell"></i>
                    </div>
                    <p>New order</p>
                  </div>
                  <br />
                  <br />

                  <div class="card-columns-two">
                    <span v-for="(item, index) of orders" :key="index">
                      <span v-if="index <= 3">
                        <div
                          class="card card-order-list calendar-border"
                          v-if="item.order_status !== 1"
                        >
                          <div class="card-body">
                            <!-- Detail newOrder -->
                            <h6 class="card-title">
                              <b>ออร์เดอร์ที่ {{ item.order_code }}</b>
                            </h6>
                            <p class="card-text">
                              <small class="text-muted">
                                <i class="fas fa-calendar-alt"></i>กำหนดรับ :
                                {{ item.mustbeget_date | moment }}
                              </small>
                            </p>
                            <p
                              class="card-text"
                              v-if="item.audit_user !== 'admin_it'"
                            >
                              <small class="text-muted">
                                <i
                                  class="fa-solid fa-lock-open text-success"
                                ></i>
                                <span class="text-success"
                                  >โปรดรับออร์เดอร์นี้</span
                                >
                              </small>
                            </p>
                            <p
                              class="card-text"
                              v-if="item.audit_user === 'admin_it'"
                            >
                              <small class="text-muted">
                                <i class="fa-solid fa-lock text-danger"></i>
                                <span class="text-danger">ออร์เดอร์ทดสอบ</span>
                              </small>
                            </p>

                            <!-- add button -->
                            <!-- row 1 -->
                            <div
                              class="card-content-pickup-new-order"
                              v-if="item.audit_user !== 'admin_it'"
                            >
                              <!-- order test -->
                              <!-- New Orders -->

                              <a
                                class="btn-floating-pickup-new-order-green btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-toggle="tooltip"
                                tabindex="0"
                                title="กดรับออร์เดอร์"
                              >
                                <i
                                  @click="addItem(item)"
                                  class="fas fa-plus-circle fa-3x"
                                ></i>
                              </a>
                              <!-- END -->
                            </div>
                            <!-- row 2 -->
                            <div
                              class="card-content-pickup-new-order"
                              v-if="item.audit_user === 'admin_it'"
                            >
                              <a
                                class="btn-floating-pickup-new-order-red btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-toggle="tooltip"
                                tabindex="0"
                                title="กดรับออร์เดอร์"
                              >
                                <i
                                  @click="addItem(item)"
                                  class="fas fa-plus-circle fa-3x"
                                ></i>
                              </a>

                              <!-- END -->
                            </div>
                            <!-- END ADD BUTTON -->
                          </div>
                        </div>
                      </span>
                    </span>

                    <button
                      @click="more('NewOrder')"
                      class="btn btn-outline-danger btn-sm more"
                      v-if="jobs > 4"
                    >
                      กดดูอีก {{ jobs - 4 }}...
                    </button>
                  </div>
                  <br v-if="jobs > 4" />
                </div>
              </div>

              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <div class="chip_job pull-left">
                    <div class="chip__icon">
                      <i class="fa-solid fa-person-walking"></i>
                    </div>
                    <p>My jobs</p>
                  </div>
                  <br />
                  <br />
                  <br/>

                  <div class="row">
                    <div
                      class="col-lg-12 col-md-12 col-xs-12"
                      v-for="(item, index) of order_me"
                      :key="index"
                    >
                      <span v-if="index <= 1">
                        <div
                          class="card card-order-list calendar-border"
                          v-if="item.order_status !== 3"
                        >
                          <div class="card-body">
                            <!-- Detail newOrder :  card-my-job-title-->
                            <h5 class="card-title">
                              <b> ออร์เดอร์ที่ {{ item.order_code }}</b>
                            </h5>
                            <div
                              class="card-content-more"
                              v-if="!orderMore[item.order_id]"
                            >
                              <p
                                class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-tooltip="Add to favorites"
                                v-if="!orderMore[item.order_id]"
                                @click="orderShowMore(item.order_id)"
                              >
                                <i class="fas fa-chevron-circle-down fa-2x"></i>
                                <!-- <i class="fas fa-ellipsis-h"></i> -->
                              </p>
                            </div>
                            <div
                              class="card-content-more"
                              v-if="orderMore[item.order_id]"
                            >
                              <p
                                class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-tooltip="Add to favorites"
                                v-if="orderMore[item.order_id]"
                                @click="orderShowLess(item.order_id)"
                              >
                                <i class="fas fa-chevron-circle-up fa-2x"></i>
                                <!-- <i class="fas fa-ellipsis-v"></i> -->
                              </p>
                            </div>
                            <!-- END -->
                            <!-- ================================= DETAIL BOOK ================================== -->
                            <!-- v-if="orderMore[item.order_id]" -->
                            <div
                              class="detail-book-my-job"
                              v-if="orderMore[item.order_id]"
                            >
                              <div
                                class="text-capitalize-myjob"
                                v-for="(prod, j) of item.order_detail"
                                :key="j"
                              >
                                <div class="card-body">
                                  <b-row>
                                    <b-col cols="4">
                                      <img
                                        class="img-my-job zoom"
                                        :src="
                                          'https://smartlibrary.ubru.ac.th/Books/' +
                                          prod.img_url
                                        "
                                        alt="Card image cap"
                                        id="cardimg"
                                      />
                                    </b-col>
                                    <b-col cols="8">
                                      <h5
                                        class="card-title"
                                        v-if="!readMore[prod.order_detail_id]"
                                      >
                                        <img
                                          src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                          alt=""
                                          style="width: 20px; height: auto"
                                          v-if="prod.trans_status === 0"
                                        />

                                        <i class="fa-solid fa-book fa-sm"></i>

                                        {{ prod.book_title.slice(0, 49) }}
                                        <a
                                          v-if="
                                            !readMore[prod.order_detail_id] &&
                                            prod.book_title.length > 49
                                          "
                                          @click="
                                            showMore(prod.order_detail_id)
                                          "
                                          >[...]</a
                                        >
                                      </h5>

                                      <h6
                                        class="card-title"
                                        v-if="readMore[prod.order_detail_id]"
                                      >
                                        <img
                                          src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                          alt=""
                                          style="width: 20px; height: auto"
                                          v-if="prod.trans_status === 0"
                                        />
                                        <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                                        <i class="fa-solid fa-book fa-sm"></i>
                                        {{ prod.book_title }}
                                        <a
                                          v-if="readMore[prod.order_detail_id]"
                                          @click="
                                            showLess(prod.order_detail_id)
                                          "
                                          >[ย่อ]</a
                                        >
                                      </h6>

                                      <h5 class="card-title barcode">
                                        <i class="fas fa-barcode fa-sm"></i>
                                        บาร์โค้ด| {{ prod.barcode }}
                                      </h5>

                                      <h6 class="card-title barcode">
                                        <i
                                          class="fas fa-map-marker-alt fa-sm"
                                        ></i>
                                        {{ prod.book_location }}
                                      </h6>

                                      <h6 class="card-title barcode">
                                        <i class="fas fa-layer-group fa-sm"></i>
                                        หมวดหมู่ |
                                        {{ prod.book_cassification }}
                                      </h6>
                                      <br />
                                    </b-col>
                                    <div
                                      class="content-status"
                                      v-if="prod.trans_status === 0"
                                    >
                                      <button
                                        class="btn btn-primary btn-status-item-info"
                                        @click="
                                          YesOrNo(
                                            1,
                                            item,
                                            prod.order_detail_id,
                                            prod.barcode
                                          )
                                        "
                                      >
                                        Yes
                                      </button>
                                      <button
                                        class="btn btn-danger btn-status-item-danger"
                                        @click="
                                          YesOrNo(
                                            2,
                                            item,
                                            prod.order_detail_id,
                                            prod.barcode
                                          )
                                        "
                                      >
                                        No
                                      </button>
                                      <span
                                        v-if="
                                          !anthor_barcode[
                                            prod.order_detail_id
                                          ] && prod.another_barcode.length !== 0
                                        "
                                      >
                                        <button
                                          v-if="
                                            !anthor_barcode[
                                              prod.order_detail_id
                                            ]
                                          "
                                          @click="
                                            anthorBarcodeMore(
                                              prod.order_detail_id
                                            )
                                          "
                                          class="btn btn-success readmore-myjob"
                                        >
                                          More
                                        </button>
                                      </span>
                                      <span
                                        v-if="
                                          anthor_barcode[
                                            prod.order_detail_id
                                          ] && prod.another_barcode.length !== 0
                                        "
                                      >
                                        <button
                                          v-if="
                                            anthor_barcode[prod.order_detail_id]
                                          "
                                          @click="
                                            anthorBarcodeLess(
                                              prod.order_detail_id
                                            )
                                          "
                                          class="btn btn-warning readmore-myjob"
                                        >
                                          Less
                                        </button>
                                      </span>
                                    </div>
                                  </b-row>
                                  <!-- ================== END IMAGE CARD ================ -->
                                  <br
                                    v-if="anthor_barcode[prod.order_detail_id]"
                                  />
                                  <br
                                    v-if="anthor_barcode[prod.order_detail_id]"
                                  />
                                  <!-- anathor barcode -->
                                  <div
                                    class="row"
                                    v-if="anthor_barcode[prod.order_detail_id]"
                                  >
                                    <div
                                      class="col-lg-12 col-md-12 col-xs-6"
                                      v-for="(
                                        bacode, k
                                      ) of prod.another_barcode"
                                      :key="k"
                                    >
                                      <div class="card-columns">
                                        <div
                                          class="card card-order-list calendar-border"
                                        >
                                          <div class="card-body">
                                            <div>
                                              <h4 class="card-title barcode">
                                                <i
                                                  class="fas fa-barcode fa-sm"
                                                ></i>
                                                บาร์โค้ด| {{ bacode.barcode }}
                                              </h4>
                                            </div>

                                            <h6 class="card-title barcode">
                                              <i
                                                class="fas fa-map-marker-alt fa-sm"
                                              ></i>
                                              {{ bacode.book_location }}
                                            </h6>
                                            <h6 class="card-title barcode">
                                              <i
                                                class="fas fa-layer-group fa-sm"
                                              ></i>
                                              หมวดหมู่ |
                                              {{ bacode.book_cassification }}
                                            </h6>
                                            <div
                                              class="content-status-more"
                                              v-if="prod.trans_status === 0"
                                            >
                                              <br />
                                              <button
                                                class="btn btn-primary btn-status-info"
                                                @click="
                                                  YesOrNo(
                                                    1,
                                                    item,
                                                    prod.order_detail_id,
                                                    bacode.barcode
                                                  )
                                                "
                                              >
                                                Yes
                                              </button>
                                              <button
                                                class="btn btn-danger btn-status-danger"
                                                @click="
                                                  YesOrNo(
                                                    2,
                                                    item,
                                                    prod.order_detail_id,
                                                    bacode.barcode
                                                  )
                                                "
                                              >
                                                No
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <!-- END row anathor barcode -->
                                  <br />
                                  <p class="card-text status-text-myjob-all">
                                    <small class="text-muted">
                                      <i class="fas fa-calendar-alt"></i>วันรับ
                                      :
                                      {{ item.mustbeget_date | moment }}
                                      <!-- {{moment(item.mustbeget_date).fromNow()}} -->
                                      <i v-if="item.order_status === 1">
                                        <img
                                          src="../../assets/icons/alram.gif"
                                          alt=""
                                          style="width: 23px; height: auto"
                                        />
                                        รีบดำเนินการ
                                      </i>

                                      <i v-if="item.order_status === 2">
                                        <img
                                          src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"
                                          alt=""
                                          style="width: 15px; height: auto"
                                        />
                                        กำลังดำเนินการ
                                      </i>
                                    </small>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <!-- END -->
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                  <br />
                  <br />
                  <button
                    @click="more('MyJob')"
                    class="btn btn-outline-danger btn-sm more"
                    v-if="myjobs > 2"
                  >
                    กดดูอีก {{ myjobs - 2 }}...
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <div class="overtime">
                    <div class="overtime_icon">
                      <i class="fa-solid fa-circle-xmark"></i>
                    </div>
                    <p>รายการเกินกำหนด</p>
                  </div>
                  <br />
                  <div class="card-columns">
                    <div v-for="(over, index) of item_overtime" :key="index">
                      <div
                        class="card card-order-list calendar-border"
                        v-if="
                          item_overtime.length !== 0 ||
                          item_overtime.length !== null
                        "
                      >
                        <div class="card-columns">
                          <div class="card-body">
                            <h6 class="card-title overtime-detail">
                              {{ over.order_code }} | ตู้ที่
                              {{ over.locker_number }} | รหัส :{{
                                over.locker_passcode
                              }}
                              <button
                                class="btn btn-warning btn-clear"
                                @click="
                                  set_overtime(over.order_code, over.std_code)
                                "
                              >
                                Clear
                              </button>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- length == 0 -->
                    <div
                      class="card card-order-list calendar-border"
                      v-if="
                        item_overtime.length === 0 ||
                        item_overtime.length === null
                      "
                    >
                      <div class="card-columns">
                        <div class="card-body">
                          <h6 class="card-title overtime-detail">
                            <i
                              class="fa-regular fa-face-smile-beam fa-2x"
                              style="color: orangered"
                            ></i>
                            วันนี้ไม่มีออร์เดอร์เกินกำหนดรับ
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>

      <!-- END All -->
      <!--========================================= New Order ================================================ -->
      <div class="detail_newOrder" v-if="radio_btn === 'NewOrder'">
        <div class="card-columns">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <div class="chip pull-left">
                    <div class="chip__icon">
                      <i class="fa-solid fa-bell"></i>
                    </div>
                    <p>New orders</p>
                  </div>
                  <br/>
                  <br/>
                  <div class="card-body">
                    <div class="row">
                      <div
                        class="col-lg-6 col-md-6 col-xs-12"
                        v-for="(item, index) of orders"
                        :key="index"
                      >
                        <div
                          class="card card-order-list calendar-border"
                          v-if="item.order_status !== 1"
                        >
                          <div class="card-body">
                            <!-- Detail newOrder -->
                            <h6 class="card-title">
                              <b> ออร์เดอร์ที่ {{ item.order_code }}</b>
                              <!-- [{{
                                item.order_detail.length +
                                +(item.order_detail.length > 1 ||
                                item.order_detail.length === 0
                                  ? ""
                                  : "")
                              }}
                              เล่ม]  -->
                            </h6>
                            <p class="card-text">
                              <small class="text-muted">
                                <i class="fas fa-calendar-alt"></i>กำหนดรับ :
                                {{ item.mustbeget_date | moment }}
                              </small>
                            </p>
                            <p
                              class="card-text"
                              v-if="item.audit_user !== 'admin_it'"
                            >
                              <small class="text-muted">
                                <i
                                  class="fa-solid fa-lock-open text-success"
                                ></i>
                                <span class="text-success"
                                  >โปรดรับออร์เดอร์นี้</span
                                >
                              </small>
                            </p>
                            <p
                              class="card-text"
                              v-if="item.audit_user === 'admin_it'"
                            >
                              <small class="text-muted">
                                <i class="fa-solid fa-lock text-danger"></i>
                                <span class="text-danger">ออร์เดอร์ทดสอบ</span>
                              </small>
                            </p>

                            <!-- add button -->
                            <!-- row 1 -->
                            <div
                              class="card-content-pickup-new-order"
                              v-if="item.audit_user !== 'admin_it'"
                            >
                              <!-- order test -->
                              <!-- New Orders -->

                              <a
                                class="btn-floating-pickup-new-order-green btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-toggle="tooltip"
                                tabindex="0"
                                title="กดรับออร์เดอร์"
                              >
                                <i
                                  @click="addItem(item)"
                                  class="fas fa-plus-circle fa-3x"
                                ></i>
                              </a>
                              <!-- END -->
                            </div>
                            <!-- row 2 -->
                            <div
                              class="card-content-pickup-new-order"
                              v-if="item.audit_user === 'admin_it'"
                            >
                              <a
                                class="btn-floating-pickup-new-order-red btn-large waves-effect waves-light pink tooltipped"
                                data-position="bottom"
                                data-delay="50"
                                data-toggle="tooltip"
                                tabindex="0"
                                title="กดรับออร์เดอร์"
                              >
                                <i
                                  @click="addItem(item)"
                                  class="fas fa-plus-circle fa-3x"
                                ></i>
                              </a>

                              <!-- END -->
                            </div>
                            <!-- END ADD BUTTON -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END New Order -->
      <!--========================================= My Job================================================ -->
      <div class="detail_myJob" v-if="radio_btn === 'MyJob'">
        <div class="card-columns">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
              <div class="card card-order-list calendar-border">
                <div class="card-body">
                  <div class="chip_job pull-left">
                    <div class="chip__icon">
                      <i class="fa-solid fa-person-half-dress"></i>
                    </div>
                    <p>My jobs</p>
                  </div>
                  <br/>
                  <br/>
                  <div class="card-body">
                    <div class="row">
                      <div
                        class="col-lg-12 col-md-12 col-xs-12"
                        v-for="(item, index) of order_me"
                        :key="index"
                      >
                        <span>
                          <div
                            class="card card-order-list calendar-border"
                            v-if="item.order_status !== 3"
                          >
                            <div class="card-body">
                              <!-- Detail newOrder :  card-my-job-title-->
                              <h5 class="card-title">
                                <b> ออร์เดอร์ที่ {{ item.order_code }}</b>
                              </h5>
                              <div
                                class="card-content-more"
                                v-if="!orderMore[item.order_id]"
                              >
                                <p
                                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                                  data-position="bottom"
                                  data-delay="50"
                                  data-tooltip="Add to favorites"
                                  v-if="!orderMore[item.order_id]"
                                  @click="orderShowMore(item.order_id)"
                                >
                                  <i
                                    class="fas fa-chevron-circle-down fa-2x"
                                  ></i>
                                  <!-- <i class="fas fa-ellipsis-h"></i> -->
                                </p>
                              </div>
                              <div
                                class="card-content-more"
                                v-if="orderMore[item.order_id]"
                              >
                                <p
                                  class="btn-floating btn-large waves-effect waves-light pink tooltipped"
                                  data-position="bottom"
                                  data-delay="50"
                                  data-tooltip="Add to favorites"
                                  v-if="orderMore[item.order_id]"
                                  @click="orderShowLess(item.order_id)"
                                >
                                  <i class="fas fa-chevron-circle-up fa-2x"></i>
                                  <!-- <i class="fas fa-ellipsis-v"></i> -->
                                </p>
                              </div>
                              <!-- END -->
                              <!-- ================================= DETAIL BOOK ================================== -->
                              <!-- v-if="orderMore[item.order_id]" -->
                              <div
                                class="detail-book-my-job"
                                v-if="orderMore[item.order_id]"
                              >
                                <div
                                  class="text-capitalize-myjob"
                                  v-for="(prod, j) of item.order_detail"
                                  :key="j"
                                >
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-lg-3 col-md-3 col-xs-12">
                                        <img
                                          class="img-my-job_"
                                          :src="
                                            'https://smartlibrary.ubru.ac.th/Books/' +
                                            prod.img_url
                                          "
                                          alt="Card image cap"
                                          id="cardimg"
                                        />
                                      </div>
                                      <div class="col-lg-9 col-md-9 col-xs-12">
                                        <h5
                                          class="card-title"
                                          v-if="!readMore[prod.order_detail_id]"
                                        >
                                          <img
                                            src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                            alt=""
                                            style="width: 20px; height: auto"
                                            v-if="prod.trans_status === 0"
                                          />

                                          <i class="fa-solid fa-book fa-sm"></i>

                                          {{ prod.book_title.slice(0, 49) }}
                                          <a
                                            v-if="
                                              !readMore[prod.order_detail_id] &&
                                              prod.book_title.length > 49
                                            "
                                            @click="
                                              showMore(prod.order_detail_id)
                                            "
                                            >[...]</a
                                          >
                                        </h5>

                                        <h6
                                          class="card-title"
                                          v-if="readMore[prod.order_detail_id]"
                                        >
                                          <img
                                            src="https://www.myprincipallifestyle.com/assets/img/loading.gif"
                                            alt=""
                                            style="width: 20px; height: auto"
                                            v-if="prod.trans_status === 0"
                                          />
                                          <!-- <i class="fas fa-spinner" style="color:blue" v-if="prod.trans_status === 0"></i> -->
                                          <i class="fa-solid fa-book fa-sm"></i>
                                          {{ prod.book_title }}
                                          <a
                                            v-if="
                                              readMore[prod.order_detail_id]
                                            "
                                            @click="
                                              showLess(prod.order_detail_id)
                                            "
                                            >[ย่อ]</a
                                          >
                                        </h6>

                                        <h5 class="card-title barcode">
                                          <i class="fas fa-barcode fa-sm"></i>
                                          บาร์โค้ด| {{ prod.barcode }}
                                        </h5>

                                        <h6 class="card-title barcode">
                                          <i
                                            class="fas fa-map-marker-alt fa-sm"
                                          ></i>
                                          {{ prod.book_location }}
                                        </h6>

                                        <h6 class="card-title barcode">
                                          <i
                                            class="fas fa-layer-group fa-sm"
                                          ></i>
                                          หมวดหมู่ |
                                          {{ prod.book_cassification }}
                                        </h6>
                                        <br />
                                        <br />
                                      </div>
                                      <div
                                        class="content-status"
                                        v-if="prod.trans_status === 0"
                                      >
                                        <button
                                          class="btn btn-primary btn-status-item-info"
                                          @click="
                                            YesOrNo(
                                              1,
                                              item,
                                              prod.order_detail_id,
                                              prod.barcode
                                            )
                                          "
                                        >
                                          Yes
                                        </button>
                                        <button
                                          class="btn btn-danger btn-status-item-danger"
                                          @click="
                                            YesOrNo(
                                              2,
                                              item,
                                              prod.order_detail_id,
                                              prod.barcode
                                            )
                                          "
                                        >
                                          No
                                        </button>
                                        <span
                                          v-if="
                                            !anthor_barcode[
                                              prod.order_detail_id
                                            ] &&
                                            prod.another_barcode.length !== 0
                                          "
                                        >
                                          <button
                                            v-if="
                                              !anthor_barcode[
                                                prod.order_detail_id
                                              ]
                                            "
                                            @click="
                                              anthorBarcodeMore(
                                                prod.order_detail_id
                                              )
                                            "
                                            class="btn btn-success readmore-myjob"
                                          >
                                            More
                                          </button>
                                        </span>
                                        <span
                                          v-if="
                                            anthor_barcode[
                                              prod.order_detail_id
                                            ] &&
                                            prod.another_barcode.length !== 0
                                          "
                                        >
                                          <button
                                            v-if="
                                              anthor_barcode[
                                                prod.order_detail_id
                                              ]
                                            "
                                            @click="
                                              anthorBarcodeLess(
                                                prod.order_detail_id
                                              )
                                            "
                                            class="btn btn-warning readmore-myjob"
                                          >
                                            Less
                                          </button>
                                        </span>
                                      </div>

                                      <!--  -->
                                    </div>
                                    <br
                                      v-if="
                                        anthor_barcode[prod.order_detail_id]
                                      "
                                    />
                                    <br
                                      v-if="
                                        anthor_barcode[prod.order_detail_id]
                                      "
                                    />
                                    <!-- anathor barcode -->
                                    <div
                                      class="row"
                                      v-if="
                                        anthor_barcode[prod.order_detail_id]
                                      "
                                    >
                                      <div
                                        class="col-lg-6 col-md-6 col-xs-6"
                                        v-for="(
                                          bacode, k
                                        ) of prod.another_barcode"
                                        :key="k"
                                      >
                                        <div class="card-columns">
                                          <div
                                            class="card card-order-list calendar-border"
                                          >
                                            <div class="card-body">
                                              <div>
                                                <h4 class="card-title barcode">
                                                  <i
                                                    class="fas fa-barcode fa-sm"
                                                  ></i>
                                                  บาร์โค้ด| {{ bacode.barcode }}
                                                </h4>
                                              </div>

                                              <h6 class="card-title barcode">
                                                <i
                                                  class="fas fa-map-marker-alt fa-sm"
                                                ></i>
                                                {{ bacode.book_location }}
                                              </h6>
                                              <h6 class="card-title barcode">
                                                <i
                                                  class="fas fa-layer-group fa-sm"
                                                ></i>
                                                หมวดหมู่ |
                                                {{ bacode.book_cassification }}
                                              </h6>
                                              <div
                                                class="content-status-more"
                                                v-if="prod.trans_status === 0"
                                              >
                                                <br />
                                                <button
                                                  class="btn btn-primary btn-status-info"
                                                  @click="
                                                    YesOrNo(
                                                      1,
                                                      item,
                                                      prod.order_detail_id,
                                                      bacode.barcode
                                                    )
                                                  "
                                                >
                                                  Yes
                                                </button>
                                                <button
                                                  class="btn btn-danger btn-status-danger"
                                                  @click="
                                                    YesOrNo(
                                                      2,
                                                      item,
                                                      prod.order_detail_id,
                                                      bacode.barcode
                                                    )
                                                  "
                                                >
                                                  No
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <!-- END row anathor barcode -->

                                    <p class="card-text status-text-myjob-all">
                                      <small class="text-muted">
                                        <i class="fas fa-calendar-alt"></i
                                        >วันรับ :
                                        {{ item.mustbeget_date | moment }}
                                        <!-- {{moment(item.mustbeget_date).fromNow()}} -->
                                        <i v-if="item.order_status === 1">
                                          <img
                                            src="../../assets/icons/alram.gif"
                                            alt=""
                                            style="width: 23px; height: auto"
                                          />
                                          รีบดำเนินการ
                                        </i>

                                        <i v-if="item.order_status === 2">
                                          <img
                                            src="https://www.superiorlawncareusa.com/wp-content/uploads/2020/05/loading-gif-png-5.gif"
                                            alt=""
                                            style="width: 15px; height: auto"
                                          />
                                          กำลังดำเนินการ
                                        </i>
                                      </small>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!-- END -->
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MyJob -->
      <!-- END Detail Tabs -->
    </b-container>
  </div>
</template>

<script>
import navbarStaff from "../layouts/navbar_staff.vue";
import axios from "axios";
import moment from "moment";
import $ from "jquery";
export default {
  components: { navbarStaff },
  name: "Dashboard",
  data() {
    return {
      jobs: [],
      myjobs: [],
      packing: [],
      ready: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      inprogress: [],
      code: "",
      item_overtime: [],
      detail: [],
      onlocker: [],
      myorders: [],
      items: [],
      newjobs: [],
      radio_btn: "",
      orders: [],
      chk_status_admin: true,
      order_me: [],
      anthor_barcode: {},
      isLoading: false,
      readMore: {},
      show: false,
      orderMore: {},
      bar: "",
      myjob: [],
    };
  },
  filters: {
    moment: function (date) {
      moment.locale("th");
      return moment(date).add(543, "year").format("DD/MM/YYYY");
    },
  },
  mounted() {
    setTimeout(() => {
      $("iframe").remove();
    }, 8000);
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
    this.newjob();
    this.dashboard();
    this.get_overtime();
    this.gethistory();
    this.getmyjob();

    // eslint-disable-next-line no-unused-vars
    const playBtn = document.querySelector(".circle__btn");
    // console.log(playBtn);
    // eslint-disable-next-line no-unused-vars
    const wave1 = document.querySelector(".circle__back-1");
    // console.log(wave1);
    // eslint-disable-next-line no-unused-vars
    const wave2 = document.querySelector(".circle__back-2");
    // console.log(wave2);
  },
  methods: {
    moment: function () {
      return moment();
    },
    onChange() {
      // console.log(this.radio_btn);
    },
    more(value) {
      this.radio_btn = value;
    },
    newjob() {
      setInterval(() => {
        let data = {
          token: this.token,
          order_status: 0,
          staff_code: this.code,
        };
        const headers = {
          "content-type": "application/json",
        };

        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/get_neworder",
            data,
            {
              headers,
            }
          )
          .then((res) => {
            this.jobs = res.data.Orders.length;
            this.packing = res.data.dasboard[0].packing;
            this.ready = res.data.dasboard[0].ready;
            this.myjobs = res.data.dasboard[0].myjob;
            this.orders = res.data.Orders;
          });
      }, 4000);
    },
    get_overtime() {
      let data = {
        token: this.token,
        std_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_overtime",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          // console.log("res",res);
          this.item_overtime = res.data.OnLockers;
          // console.log("Overtime===", this.item_overtime);
        });
    },
    dashboard() {
      let data = {
        token: this.token,
      };
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/get_dasboard",
          data,
          {
            headers,
          }
        )
        .then((res) => {
          this.inprogress = res.data.dasboard[0].inprogress;
        });
    },
    history() {
      this.$router.push("/history");
    },
    gethistory() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      // this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_history", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          this.ready = res.data.dasboard[0].ready;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.onlocker = res.data.OnLockers;
          // console.log(this.onlocker);
          this.myorders = res.data.MyOrders;
          this.items = res.data.AllOrders;

          // console.log(typeof this.items[0].mustbeget_date);
        });
    },
    set_overtime(order_code, std_code) {
      let ip = localStorage.getItem("IP");
      // console.log(ip);
      let data = {
        token: this.token,
        staff_code: this.code,
        std_code: std_code,
        order_code: order_code,
        public_ip: ip,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_overtime",
          data,
          { headers }
        )
        .then((res) => {
          this.item_overtime = res.data.OnLockers;
          // console.log(res.data.OnLockers);
        });
    },
    YesOrNo(status, item, id, newbarcode) {
      // console.log("Status yes ====ORNo");
      for (var i in item.order_detail) {
        if (item.order_detail[i].order_detail_id === id) {
          item.order_detail[i].trans_status = status;
          this.bar = item.order_detail[i].barcode;
          this.order_me.push(item);
          const seen = new Set();
          this.order_me = this.order_me.filter((el) => {
            const duplicate = seen.has(el.order_code);
            seen.add(el.order_code);
            return !duplicate;
          });
        }
      }
      let IP = localStorage.getItem("IP");
      let data = {
        token: this.token,
        order_code: item.order_code,
        staff_code: this.code,
        trans_status: status,
        public_ip: IP,
        barcode: this.bar,
        new_barcode: newbarcode,
      };
      // console.log(data);
      const headers = {
        "content-type": "application/json",
      };
      axios
        .post(
          "https://smartlibrary.ubru.ac.th/api/booking/set_trans_status",
          data,
          { headers }
        )
        .then((res) => {
          // console.log("get y or n",res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
            this.getmyjob();
          } else {
            if (item.order_code === res.data.Orders[0].order_code) {
              if (res.data.Orders[0].order_status === 3) {
                this.order_me.splice(this.order_me.indexOf(item), 1);
                // this.packing = res.data.dasboard[0].packing;
                this.jobs = res.data.dasboard[0].neworders;
                // this.ready = res.data.dasboard[0].ready;
              }
            }
          }
        });
    },
    getmyjob() {
      let data = {
        token: this.token,
        order_status: 1,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };

      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_myjob", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg.status != 200) {
            alert(res.data.msg.message);
          } else {
            this.order_me = res.data.Orders;

            this.myjobs = this.myjob.length;
          }
        });
    },
    addItem(item) {
      let IP = localStorage.getItem("IP");
      if (this.code === null || this.code === "") {
        this.$router.push("/login");
      }
      {
        let data = {
          token: this.token,
          staff_code: this.code,
          public_ip: IP,
          order_code: item.order_code,
        };

        const headers = {
          "content-type": "application/json",
        };
        axios
          .post(
            "https://smartlibrary.ubru.ac.th/api/booking/set_order_status",
            data,
            { headers }
          )
          .then((res) => {
            if (res.data.msg.status != 200) {
              this.$router.push("/login");
            } else {
              this.orders.splice(this.orders.indexOf(item), 1);
              this.getmyjob();
            }
          });
      }
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    orderShowMore(id) {
      this.$set(this.orderMore, id, true);
    },
    orderShowLess(id) {
      this.$set(this.orderMore, id, false);
    },
    anthorBarcodeMore(id) {
      this.$set(this.anthor_barcode, id, true);
    },
    anthorBarcodeLess(id) {
      this.$set(this.anthor_barcode, id, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.space {
  height: 90px;
}

/*new Order*/
.more {
  position: absolute;
  bottom: 10px;
  right: 50px;
  font-size: 15px;
}
.card-content-new-order {
  position: relative;
}
.btn-floating-pickup-new-order-green {
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 12px;
  color: green;
}

.btn-floating-pickup-new-order-red {
  position: absolute;
  bottom: 0px;
  right: 0px;
  font-size: 12px;
  color: red;
}

/*END*/

/*Overtime*/
.overtime {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overtime_icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: orangered;
}
.overtime p {
  font-size: 1rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.overtime-detail {
  margin-bottom: 0px;
  margin-top: 0px;
}

/*END*/

/*  CHIP new order */
.chip_job {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip {
  grid-column: 2/3;
  grid-row: 3/4;
  justify-self: center;
  width: 15rem;
  height: 3rem;
  border-radius: 1rem;
  /*  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
      -0.2rem -0.2rem 0.5rem var(--white);*/
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chip__icon {
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  margin: 0 0 0 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  color: orangered;
}
.chip_job p {
  font-size: 1.3rem;
  margin-right: 6.4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip p {
  font-size: 1.3rem;
  margin-right: 4rem;
  margin-top: 1rem;
  color: var(--greyDark);
  font-weight: bold;
}
.chip__close {
  width: 1.6rem;
  height: 1.6rem;
  margin: 0 0.5rem;
  display: flex;
  font-size: 1.6rem;
  color: var(--greyLight-3);
  cursor: pointer;
}
/*END */
.dashbord {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}

/*  Avatar BUTTON  */
.circle_content {
  position: relative;
}
.circle_img {
  width: 100%;
  height: auto;
  border-radius: 50%;
}
.circle_floting {
  position: absolute;
  top: -10px;
  left: -22px;
  font-size: 14px;
}
.circle {
  grid-column: 2/3;
  grid-row: 4/6;
  width: 8rem;
  height: 100%;
  justify-self: center;
  border-radius: 1rem;
  display: grid;
  grid-template-rows: 1fr;
  justify-items: center;
  align-items: center;
}
.circle__btn {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 9rem;
  height: 6rem;
  display: flex;
  margin: 0.6rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 3.2rem;
  color: var(--primary);
  z-index: 300;
  background: var(--greyLight-1);
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  cursor: pointer;
  position: relative;
}
.circle__btn.shadow {
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
}
.circle__btn .play {
  position: absolute;
  opacity: 0;
  transition: all 0.2s linear;
}
.circle__btn .play.visibility {
  opacity: 1;
}
.circle__btn .pause {
  position: absolute;
  transition: all 0.2s linear;
}
.circle__btn .pause.visibility {
  opacity: 0;
}
.circle__back-1,
.circle__back-2 {
  grid-row: 1/2;
  grid-column: 1/2;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  filter: blur(1px);
  z-index: 100;
}
.circle__back-1 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  background: linear-gradient(
    to bottom right,
    var(--greyLight-3) 0%,
    var(--white) 100%
  );
  -webkit-animation: waves 4s linear infinite;
  animation: waves 4s linear infinite;
}
.circle__back-1.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}
.circle__back-2 {
  box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
    -0.4rem -0.4rem 0.8rem var(--white);
  -webkit-animation: waves 4s linear 2s infinite;
  animation: waves 4s linear 2s infinite;
}
.circle__back-2.paused {
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

@-webkit-keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes waves {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}
/*END */
/* tebs content */
.tebs_content {
  position: relative;
}
.tebs_floting {
  position: absolute;
  top: 0px;
  left: 0px;
  font-size: 14px;
}

.segmented-control {
  grid-column: 3/4;
  grid-row: 1/2;
  width: 19.5rem;
  height: 3.4rem;
  box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
    -0.2rem -0.2rem 0.5rem var(--white);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  position: relative;
}
.segmented-control input {
  display: none;
}
.segmented-control > input:checked + label {
  transition: all 0.5s ease;
  color: rgb(209, 95, 2);
}
.segmented-control__1,
.segmented-control__2,
.segmented-control__3 {
  width: 6.3rem;
  height: 3.6rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #ff5f2d;
  transition: all 0.5s ease;
  margin-top: 1.5rem;
}
.segmented-control__1:hover,
.segmented-control__2:hover,
.segmented-control__3:hover {
  color: rgb(209, 95, 2);
}
.segmented-control__color {
  position: absolute;
  height: 2.5rem;
  width: 6.6rem;
  margin-left: 0.3rem;
  border-radius: 0.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  pointer-events: none;
}

#tab-1:checked ~ .segmented-control__color {
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-2:checked ~ .segmented-control__color {
  transform: translateX(6rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

#tab-3:checked ~ .segmented-control__color {
  transform: translateX(12.2rem);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
/* end*/
/* Card */
.card-header:first-child {
  /* border-radius: 0px; */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-columns-two {
  column-count: 2;
}
.card-columns-four {
  column-count: 4;
}

.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.shadow-date {
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.text-muted i {
  margin: 0 5px;
}
/* */
/* Noti */
.icon-button__badge_new_order {
  position: absolute;
  top: 10px;
  right: 4%;
  width: 11px;
  height: 11px;
  background: rgb(105, 105, 105);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
}
.icon-button__badge_myjob {
  position: absolute;
  top: 10px;
  right: 40%;
  width: 11px;
  height: 11px;
  background: rgb(105, 105, 105);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
}
/*END*/
/*my Job*/
.text-capitalize {
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 3.8rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: orangered;
}
.card-my-job-title {
  margin-left: -4rem;
}
.card-content-more {
  position: relative;
}
.btn-floating {
  position: absolute;
  bottom: 0;
  right: -20px;
  /* top: -100px; */
  font-size: 17px;
  color: rgb(79, 159, 0);
}
.img-my-job {
  border-radius: 10px;
  margin-left: -10px;
  margin-top: -0.5rem;
  width: 100%;
  height: auto;
}
.img-my-job_ {
  border-radius: 10px;
  margin-left: -10px;
  margin-top: -0.5rem;
  height: 169px;
}
.text-capitalize-myjob {
  border: none;
  border-radius: 1rem;
  font-size: 1.4rem;
  padding-left: 0rem;
  padding-right: 0rem;
  box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
    inset -0.2rem -0.2rem 0.5rem var(--white);
  background: none;
  font-family: inherit;
  color: rgb(29, 29, 29);
  margin-bottom: 1rem;
  margin-left: 1rem;
}
.content-status {
  position: relative;
  top: 3rem;
}
.content-status-more {
  position: relative;
  top: 1rem;
}

.btn-status-item-info {
  position: absolute;
  top: 9.5rem;
  right: 50px;

  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}
.btn-status-item-danger {
  position: absolute;
  top: 9.5rem;
  right: 0px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}

.btn-status-info {
  position: absolute;
  top: -20px;
  right: 40px;

  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}
.btn-status-danger {
  position: absolute;
  top: -20px;
  right: -18px;
  /* top: -100px; */
  font-size: 16px;
  /* color: rgb(79, 159, 0); */
}
.content-yes-no {
  position: relative;
  /* background-color: blue;*/
}
.btn-content-yes {
  position: absolute;
  margin-left: 100px;
}

.btn-content-no {
  position: absolute;
}
.readmore-myjob {
  position: absolute;
  top: 9.5rem;
  right: 8rem;
  /* top: -100px; */
  font-size: 16px;
}
.status-text-myjob-all {
  font-size: 1rem;
}

/*.btn-floating-changbacode {
    position: absolute;
   
    margin-left: 13rem;
    margin-top:2rem;
  }*/
/* card */
@media (max-width: 900px) {
  .circle_floting {
    position: absolute;
    /* width: 46px;
      height: 40px;
      
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-size: 12px; */
    top: -25px;
    left: -7rem;
    font-size: 14px;
  }
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 2;
  }
}
@media (min-height: 414px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 2;
  }
  .card-columns-four {
    column-count: 2;
  }
}
@media (max-height: 500px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 1;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-four {
    column-count: 2;
  }
}
@media (min-width: 768px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }

  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .card-columns {
    column-count: 1;
  }
  .card-columns-two {
    column-count: 2;
  }
  .card-columns-left {
    column-count: 1;
  }
  .card-columns-left-item {
    column-count: 3;
  }
  .card-columns-right-item {
    column-count: 3;
  }
  .time-column {
    column-count: 1;
  }
  .card-columns-four {
    column-count: 4;
  }
}
</style>
